import * as React from "react";
import * as ReactDOM from "react-dom";
import { OptionalLink } from "../optionalLink";

interface IProperties
{
    /**
     * Anzeige Text.
     */
    text?: string,

    /**
     * Name des Icons welches angezeigt werden soll.
     */
    icon?: string,

    /**
     * Link (react-router).
     */
    linkTo?: string | {},

    /**
     * Wird ausgeführt, sobald auf das Item geklickt wird.
     */
    onClick?: (e: MouseEvent) => void
}

export class HeaderMenuItem extends React.Component<IProperties>
{
    /**
     * Standardwerte setzen.
     */
    public static defaultProps: Partial<IProperties> = {
        icon: "menu"
    };

    /**
     * Führt die "onClick" Eigenschaft aus wenn diese gesetzt wurde.
     * @param e Das auslösende Ereignis.
     */
    private onClick = (e: React.MouseEvent<HTMLElement>) =>
    {
        this.props.onClick && this.props.onClick(e.nativeEvent);
    }

    /**
     * Rendert diese Komponente.
     */
    public render(): JSX.Element
    {
        var content = <i className={`header_menu-item_icon mdi mdi-${this.props.icon}`}></i>;

        return (
            <OptionalLink
                className="header_menu-item"
                to={this.props.linkTo}
                onClick={this.onClick}>
                {content}
            </OptionalLink>
        );
    }
}